/* eslint-disable react-hooks/exhaustive-deps */
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { userDetail } from "Stores/userDetail";
import makeApi, { URLS } from "Utils/apiURL";
import { Utils } from "Utils/utils";
import JumpBallLoader from "../../../Components/common/JumpBallLoader";
import { loginValidate } from "../../../Utils/commonAPI";
import "./authenticate.scss";

const Authenticate = props => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isLoggedIn = userDetail.userInfo.userLoggedIn;
  const isSalesIntelHost = () =>
    window.location.hostname === "prospectconnect.qa.salesintel.io" ||
    window.location.hostname === "prospectconnect.salesintel.io" ||
    window.location.hostname === "localhost";

  const whiteLabel = async async => {
    try {
      const config = {
        url: URLS.whiteLableConfig,
        method: "GET"
      };
      let response = await makeApi(config);
      let { featuresDisabled = [] } = response?.data;
      const stringifiedFeaturesDisabled = JSON.stringify(featuresDisabled);
      localStorage.setItem("featuresDisabled", stringifiedFeaturesDisabled);
      userDetail.setFeaturesDisabled(featuresDisabled);
      const event = new CustomEvent("featuresDisabled", {
        detail: featuresDisabled
      });
      window.dispatchEvent(event);
    } catch (err) {
      console.error(err);
    }
  };

  const authenticate = async (authCode, token) => {
    try {
      setLoading(true);
      setError(null);

      const params = new URLSearchParams();
      if (authCode) params.append("authCode", authCode);
      if (token) params.append("token", token);
      params.append("host", window.location.hostname);

      let response = await makeApi({
        url: `${URLS.authenticate}?${params.toString()}`,
        method: "GET"
      });

      if (response?.data?.success === "true") {
        localStorage.setItem("onToken", response?.data?.ontoken);
        await loginCheck();
      } else {
        if (isSalesIntelHost()) {
          props.history.push("/login");
          return;
        }
        setError(response?.data?.message || "Something went wrong");
      }
    } catch (err) {
      if (isSalesIntelHost()) {
        props.history.push("/login");
        return;
      }
      console.error("Authentication failed:", err);
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const checkUserTeam = async () => {
    try {
      const config = {
        url: URLS.getCurrentTeam,
        method: "GET"
      };
      const response = await makeApi(config);
      // Check if user has a team - response should have team data
      if (response?.data && Object.keys(response.data).length > 0) {
        return true;
      }
      return false;
    } catch (err) {
      console.error("Error checking user team:", err);
      return false;
    }
  };

  const logoutUser = async () => {
    try {
      const config = {
        url: URLS.logout,
        method: "POST"
      };
      await makeApi(config);
      // Clear user info and redirect to login
      userDetail.setUserInfo({ userLoggedIn: false });
      localStorage.removeItem("featuresDisabled");
      localStorage.removeItem("onToken");
    } catch (err) {
      console.error("Error during logout:", err);
    }
  };

  const loginCheck = async () => {
    const res = await loginValidate();
    if (res) {
      // Check if user has a team
      const hasTeam = await checkUserTeam();
      if (!hasTeam) {
        // User doesn't have a team, logout and redirect to login
        await logoutUser();
        props.history.push("/login");
        return;
      }
      // User has a team, proceed with whiteLabel and redirect to dashboard
      await whiteLabel();
      const onToken = localStorage.getItem("onToken");
      window.parent.postMessage({ type: "PLUGIN_LOGIN_SUCCESS", data: { onToken } }, "*");
      props.history.push("/dashboard");
    } else {
      props.history.push("/login");
    }
  };

  useEffect(() => {
    const handleLoggedInUser = async () => {
      // Check if logged in user has a team
      const hasTeam = await checkUserTeam();
      if (!hasTeam) {
        // User doesn't have a team, logout and redirect to login
        await logoutUser();
        props.history.push("/login");
        return;
      }
      // User has a team, redirect to dashboard
      props.history.push("/dashboard");
    };

    if (isLoggedIn) {
      handleLoggedInUser();
      return;
    }

    const query = Utils.getQueryParams(props.location.search);
    const authCode =
      query.get("auth_code") === null
        ? query.get("code")
        : query.get("auth_code");
    const token = query.get("token");

    if (authCode) {
      authenticate(authCode, token);
    } else if (isSalesIntelHost()) {
      props.history.push("/login");
      return;
    } else {
      setLoading(false);
      setError("No auth code provided");
    }
  }, [props.location.search, props.history, isLoggedIn]);

  return (
    <div className="auth-page">
      {error ? (
        <div className="error-message">
          <h2>Authentication Failed</h2>
          <hr />
          <p>{error}</p>
        </div>
      ) : (
        <JumpBallLoader />
      )}
    </div>
  );
};

export default withRouter(observer(Authenticate));
